import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-85ab6224"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "cms-card-block",
  style: {
    "position": "relative"
  }
};
const _hoisted_5 = {
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "media_box"
};
const _hoisted_8 = ["onClick", "src"];
const _hoisted_9 = {
  style: {
    "flex": "1",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
import MediaInfoItem from '../MediaInfo/MediaInfoItem/index.vue';
import SubtitleDialog from '../components/SubtitleDialog/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import { useI18n } from 'vue-i18n';
import { useVodLanguages } from '@/utils/cacheData';
import { scrollIntoView } from '@/utils/tools';
import { provide } from 'vue';
import { elMessage } from '@/utils';
import { getMovieInfoApi, updateMovieInfoApi } from '@/api/vodNew';
import HeaderSearch from '../MediaInfo/HeaderSearch.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const subtitleDialogRef = ref();
    const FormRef = ref(); // 标记数据是否发生变化

    const isChange = ref(false); // 初始状态

    const initialFormData = ref(null);
    const mediaItemIndex = ref(undefined); // 是否有一个未展开，false: 需要折叠 || true :需要展开

    const oneTableDontShow = computed(() => {
      let dontShow = searchConfig.formData.mediaList.some(item => !item.isShowTable);
      return dontShow;
    });
    const checkedList = ref([]);
    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    provide('languageOptions', languageOptions);
    const selectOptions = computed(() => {
      const options = [];
      languageOptions.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    });
    const buttonOptions = reactive({
      visible: false,
      action: 'addDrama',
      config: {
        title: '',
        destroyOnClose: true
      },
      buttonsList: [{
        label: '添加影片',
        type: 'primary',
        func: () => {
          addMediaInfo();
        }
      }, {
        label: '保存',
        type: 'primary',
        func: () => {
          handleComplete();
        }
      }]
    });
    const componentData = reactive({
      showLoading: false,
      name: '',
      currentMediaItemIndex: undefined
    });
    const searchConfig = reactive({
      formData: {
        name: componentData.name,
        language: 'en',
        subtitleList: [{
          language: '',
          filePath: ''
        }],
        mediaList: [{
          name: '',
          audioLanguage: 'en',
          isShowTable: true,
          sequence: 1,
          mediaContentList: [{
            videoCode: 'H264',
            videoResolution: '240P'
          }],
          subtitleList: [{
            language: '',
            filePath: ''
          }]
        }]
      },
      formList: [{
        label: '影片名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入影片名称',
        rules: [{
          required: true,
          message: '请输入影片名称',
          trigger: 'blur'
        }]
      }, {
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        placeholder: '请选择语言',
        filterable: true,
        valueKey: 'code',
        rules: [{
          required: true,
          message: '请选择语言',
          trigger: 'change'
        }],
        list: languageOptions
      }, {
        label: '排序',
        prop: 'sequence',
        widgetType: 'input',
        maxlength: 4,
        rules: [{
          required: true,
          trigger: 'blur',
          validator: (rules, value, callback) => {
            if (!value) {
              callback(new Error(t('请输入剧集编号')));
            }

            if (searchConfig.formData.mediaList.length > 1) {
              let num = 0;
              searchConfig.formData.mediaList.forEach(item => {
                if (item.sequence == value) {
                  num++;
                }
              }); // todo 暂时放开限制
              // if (num > 1) {
              //     callback(new Error(t('剧集编号不能重复')));
              // }
            }

            if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            }

            callback();
          }
        }],
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');
          searchConfig.formData.mediaList.forEach((item, index) => {
            FormRef.value?.validateField(`mediaList[${String(index)}].sequence`);
          });
        }
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '添加字幕'
      },
      confirm: () => {
        const {
          selectData
        } = subtitleDialogRef.value.selectTableConfig;
        addSubtitleItem(selectData, searchConfig.formData.mediaList[componentData.currentMediaItemIndex].subtitleList);
        subtitleDialogRef.value.multipleTable.commonTableRef.clearSelection();
        dialogConfig.visible = false;
      }
    }); // 删除影片

    const deleteMediaBtn = index => {
      if (searchConfig.formData.mediaList.length === 1) {
        return elMessage('warning', '至少保留一个影片');
      }

      mediaItemIndex.value = index;
      deleteDialogConfig.visible = true;
    }; // 删除按钮弹框


    const deleteDialogConfig = reactive({
      visible: false,
      action: 'delete',
      config: {
        title: '提示'
      },
      confirm: done => {
        searchConfig.formData.mediaList.splice(mediaItemIndex.value, 1);
        deleteDialogConfig.visible = false;
        setTimeout(() => {
          done();
        }, 500);
      }
    }); // 往数组里添加字幕

    const addSubtitleItem = (selectData, subtitleList) => {
      let time = 0;
      selectData.forEach((item, index) => {
        if (time < selectData.length) {
          subtitleList.forEach((subItem, subIndex) => {
            if (!subItem.language && !subItem.filePath && time <= selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList[subIndex] = {
                  language: item.language,
                  filePath: item.filePath // url: item.url,

                };
              }
            } else if (subIndex === subtitleList.length - 1 && time < selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList.push({
                  language: item.language,
                  filePath: item.filePath // url: item.url,

                });
              }
            }
          });
        }
      });
    }; // 排除 isShowTable 字段的工具函数


    const excludeIsShowTable = data => {
      if (!data) return data;
      return JSON.parse(JSON.stringify(data, (key, value) => {
        if (key === 'isShowTable') return undefined; // 排除 isShowTable 字段

        return value;
      }));
    }; // 获取影片详情


    const getProgramInfoById = async () => {
      componentData.showLoading = true;
      let params = {
        //...props.detailInfo,
        movieId: props.detailInfo.id,
        // programType: props.detailInfo.programType,
        infoType: 1
      };

      try {
        const res = await getMovieInfoApi(params);

        if (res.code == '0') {
          res.data && res.data.forEach((media, i) => {
            media.isOnline = media.releaseStatus == 'online' ? true : false; // 默认显示第一个字幕url表单

            media.isShowTable = i == 0 ? true : false; // 后台给的排序有问题，需要手动排序

            media.sequence = i + 1;
          });
          res.data.subtitleList = res.data.subtitleList ? res.data.subtitleList : [{
            language: '',
            filePath: ''
          }]; //字幕，没有字幕要给个默认选项

          searchConfig.formData.mediaList = res.data; // 保存初始状态，排除 isShowTable 字段

          initialFormData.value = excludeIsShowTable(searchConfig.formData);
          setTimeout(() => {
            componentData.showLoading = false;
          }, 1000);
        } else {
          componentData.showLoading = false;
        }
      } catch (error) {
        console.log('254-err', error);
        componentData.showLoading = false;
      }
    }; // 添加影片


    const addMediaInfo = () => {
      let sequence = searchConfig.formData.mediaList.length;
      searchConfig.formData.mediaList.push({
        name: componentData.name,
        audioLanguage: '',
        isShowTable: true,
        movieId: props.detailInfo.id,
        sequence: sequence + 1,
        mediaContentList: [{
          videoCode: 'H264',
          videoResolution: '240P'
        }],
        subtitleList: [{
          language: '',
          filePath: ''
        }]
      });
    }; // 影片的搜索字幕


    const searchMediaSubtitle = (tagIndex = 0) => {
      dialogConfig.visible = true;
      componentData.currentMediaItemIndex = tagIndex;
    };

    const addMedia = index => {
      searchConfig.formData.mediaList[index].mediaContentList.push({
        videoCode: 'H264',
        videoResolution: '240P'
      });
    };

    const deleteMediaItem = (index, mediaIndex) => {
      if (mediaIndex === 0) {
        if (searchConfig.formData.mediaList[index].mediaContentList.length === 1) {
          searchConfig.formData.mediaList.splice(index, 1);
        } else {
          searchConfig.formData.mediaList[index].mediaContentList.splice(mediaIndex, 1);
        }
      } else {
        searchConfig.formData.mediaList[index].mediaContentList.splice(mediaIndex, 1);
      }
    };

    const addSubtitle = index => {
      searchConfig.formData.mediaList[index].subtitleList.push({
        language: '',
        filePath: ''
      });
    };

    const deleteSubtitleItem = (index, subtitleIndex) => {
      searchConfig.formData.mediaList[index].subtitleList.splice(subtitleIndex, 1);
    };

    const initFormData = () => {
      return {
        name: componentData.name,
        language: 'en',
        subtitleList: [{
          language: '',
          filePath: ''
        }],
        mediaList: [{
          name: '',
          isShowTable: true,
          audioLanguage: 'en',
          sequence: 1,
          mediaContentList: [{
            videoCode: 'H264',
            videoResolution: '240P'
          }],
          subtitleList: [{
            language: '',
            filePath: ''
          }]
        }]
      };
    };

    const handleComplete = () => {
      FormRef.value.validate((valid, invalidFields) => {
        if (valid) {
          editMoviePlayUrl();
        } else {
          scrollIntoView();
        }
      });
    };

    const editMoviePlayUrl = async () => {
      componentData.showLoading = true;

      try {
        let postData = JSON.parse(JSON.stringify(searchConfig.formData.mediaList));
        postData.forEach(item => item.movieId = props.detailInfo.id);
        const res = await updateMovieInfoApi(postData);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          emit('update:modelValue', false);
          emit('update-list');
        }
      } catch (error) {
        console.log('454----', error);
      }

      componentData.showLoading = false;
    };

    const back = () => {
      // 未做任何修改直接返回
      if (!isChange.value) {
        emit('update-list');
        return emit('update:modelValue', false);
      }

      backDialogConfig.visible = true;
    };

    const isChecked = index => {
      const idx = checkedList.value.indexOf(index);
      return idx === -1 ? false : true;
    };

    const handleCheckChange = index => {
      const idx = checkedList.value.indexOf(index);

      if (idx !== -1) {
        checkedList.value.splice(idx, 1);
      } else {
        checkedList.value.push(index);
      }
    }; // 搜索字幕


    const searchSubtitle = index => {
      componentData.currentMediaItemIndex = index;
      dialogConfig.visible = true;
    }; // 返回按钮的弹框


    const backDialogConfig = reactive({
      visible: false,
      config: {
        title: '提示'
      },
      confirm: done => {
        emit('update:modelValue', false);
        emit('update-list');
        backDialogConfig.visible = false;
        setTimeout(() => {
          done();
        }, 500);
      }
    }); // 展开

    const showAllTable = () => {
      searchConfig.formData.mediaList.forEach(item => item.isShowTable = oneTableDontShow.value);
    }; // 监听formData变化，有变化则标记已修改，用于返回上一步的判断


    watch(() => searchConfig.formData, newVal => {
      if (initialFormData.value) {
        // 比较时排除 isShowTable 字段
        const newData = excludeIsShowTable(newVal);
        const initialData = excludeIsShowTable(initialFormData.value);

        if (JSON.stringify(newData) !== JSON.stringify(initialData)) {
          isChange.value = true;
        }
      }
    }, {
      deep: true
    });
    watch(() => props.modelValue, async val => {
      if (val) {
        getAllLanguages();
        getProgramInfoById();
      } else {
        searchConfig.formData = initFormData();
        checkedList.value = [];
        isChange.value = false;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('影片列表')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        type: "text",
        style: {
          "position": "absolute"
        },
        onClick: showAllTable
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(oneTableDontShow) ? _ctx.$t('展开') : _unref(t)('折叠')), 1), _createElementVNode("img", {
          src: _unref(oneTableDontShow) ? require('@/assets/imgs/arrow_down.png') : require('@/assets/imgs/arrow_up.png'),
          alt: ""
        }, null, 8, _hoisted_6)]),
        _: 1
      }), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": buttonOptions.buttonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_el_form, {
        model: searchConfig.formData,
        ref_key: "FormRef",
        ref: FormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchConfig.formData.mediaList, (tagItem, tagIndex) => {
          return _openBlock(), _createElementBlock("div", {
            style: {
              "margin-bottom": "24px"
            },
            key: tagIndex
          }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("img", {
            onClick: $event => tagItem.isShowTable = !tagItem.isShowTable,
            class: "pointer mg-r--15",
            src: tagItem.isShowTable ? require('@/assets/imgs/dropdown.png') : require('@/assets/imgs/dropup.png'),
            alt: ""
          }, null, 8, _hoisted_8)]), _createVNode(HeaderSearch, {
            c_index: tagIndex,
            class: "movie-search-input",
            isShowBtns: false,
            disabled: tagItem.releaseStatus == 'online',
            "form-list": searchConfig.formList,
            "form-data": tagItem,
            "program-type": "movie"
          }, {
            customBtn: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
              type: "text",
              onClick: $event => searchMediaSubtitle(tagIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('搜索字幕')), 1)]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "text",
              onClick: $event => addSubtitle(tagIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加字幕')), 1)]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "text",
              onClick: $event => addMedia(tagIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加影片')), 1)]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "text",
              onClick: $event => deleteMediaBtn(tagIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["c_index", "disabled", "form-list", "form-data"])]), _withDirectives(_createVNode(MediaInfoItem, {
            onAddMediaInfo: addMediaInfo,
            onSearchSubtitle: searchMediaSubtitle,
            c_index: tagIndex,
            programType: __props.detailInfo.programType,
            formData: searchConfig.formData.mediaList,
            onAddMedia: addMedia,
            onDeleteMediaItem: deleteMediaItem,
            onAddSubtitle: addSubtitle,
            onDeleteSubtitleItem: deleteSubtitleItem,
            checkedList: checkedList.value
          }, null, 8, ["c_index", "programType", "formData", "checkedList"]), [[_vShow, tagItem.isShowTable]])]);
        }), 128))]),
        _: 1
      }, 8, ["model"])])])), [[_directive_loading, componentData.showLoading]])])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: deleteDialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => deleteDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: deleteDialogConfig.config,
        onOnConfirm: deleteDialogConfig.confirm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确认删除勾选影片吗?')), 1)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: backDialogConfig.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => backDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: backDialogConfig.config,
        onOnConfirm: backDialogConfig.confirm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('修改还未保存，确定离开?')), 1)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SubtitleDialog, {
          modelValue: dialogConfig.visible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogConfig.visible = $event),
          ref_key: "subtitleDialogRef",
          ref: subtitleDialogRef,
          programType: __props.detailInfo.programType,
          languageOptions: languageOptions.value,
          formData: searchConfig.formData
        }, null, 8, ["modelValue", "programType", "languageOptions", "formData"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});